import * as React from 'react';
import { connect } from 'react-redux';
import { Error } from '@pec/aion-ui-components/components/Error';
import { fetchQuestionnaireSectionsIfNeeded } from '@pec/aion-ui-core/actions/questionnaireSections';
import { History } from 'history';
import { Loading } from '@pec/aion-ui-components/components/Loading';
import { QuestionnaireSectionStatus } from '@pec/aion-ui-core/interfaces/questionnaireSection';
import { RootActions } from 'combineActions';
import { RootState } from 'combineReducers';
import { RouteComponentProps, withRouter } from 'react-router';
import { ThunkDispatch } from 'redux-thunk';
import { filterQuestionnaireSections } from '../../helpers/helpers';

type RouteParams = {
  organizationId: string;
};

type OwnProps = {
  history?: History;
  isEnabled?: boolean;
};

const mapStateToProps = (
  { questionnaireSections: { questionnaireSections, error }, options: { questionnaireLastViewedSectionId } }: RootState,
  ownProps: OwnProps
) => {
  const questionnaireSectionsRemaining = filterQuestionnaireSections(questionnaireSections, ownProps.isEnabled);
  const defaultSection =
    questionnaireSectionsRemaining &&
    (questionnaireSectionsRemaining.find(q => q.id.toString() === questionnaireLastViewedSectionId) ||
      questionnaireSectionsRemaining.find(q => q.status !== QuestionnaireSectionStatus.Complete) ||
      questionnaireSectionsRemaining[0]);

  return {
    questionnaireSections: questionnaireSectionsRemaining,
    defaultSectionId: defaultSection && defaultSection.id,
    error
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, null, RootActions>,
  {
    match: {
      params: { organizationId }
    }
  }: RouteComponentProps<RouteParams>
) => ({
  fetchQuestionnaireSectionsIfNeeded: () => dispatch(fetchQuestionnaireSectionsIfNeeded(organizationId))
});

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<RouteParams> &
  OwnProps;

class QuestionnaireRedirect extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.fetchQuestionnaireSectionsIfNeeded();
  }

  componentDidMount() {
    this.redirectToDefaultSectionOrDashboard();
  }

  componentDidUpdate() {
    this.redirectToDefaultSectionOrDashboard();
  }

  redirectToDefaultSectionOrDashboard() {
    const {
      questionnaireSections,
      defaultSectionId,
      history,
      match: {
        params: { organizationId }
      },
      isEnabled
    } = this.props;

    if (defaultSectionId && history) {
      history.replace(`/${organizationId}/questionnaire/${defaultSectionId}`);
    }

    // Note: redirect to company dashboard if no questionnaire sections are available
    if (isEnabled && Array.isArray(questionnaireSections) && questionnaireSections.length === 0 && history) {
      history.replace(`/${organizationId}`);
    }
  }

  render() {
    return this.props.error ? <Error /> : <Loading />;
  }
}

export const QuestionnaireRedirectContainer = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(QuestionnaireRedirect)
);
